<template>
  <div>
    <loader></loader>
    <no-habilitado v-if="!habilitado" perfil="Administradores"></no-habilitado>
    <app-error v-if="error" :errorMensaje="errorMensaje"></app-error>
    <h1 style="margin-top:100px; margin-left:50px">Administrar categorias</h1>
    <app-categories-grid></app-categories-grid>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CategoriesGrid from "../categories/CategoriesGrid.vue";
import Loader from "../shared/Loader";
import NoHabilitado from "../shared/NoHabilitado";
import appError from "../shared/Error";

export default {
  name: "app",
  data() {
    return {
      habilitado:false,
      error:false
    };
  },
  methods: {},
  computed: {
    ...mapGetters(["userLogged"])
  },
  components: {
    appCategoriesGrid: CategoriesGrid,
    Loader: Loader,
    NoHabilitado: NoHabilitado,
    appError: appError
  },

  mounted: function() {
    if (this.userLogged.profile == "ADMINISTRADOR") {
      this.habilitado = true;
      const loader = document.querySelector(".loader");
      loader.className += " hidden";
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/admin/AdminCategories.vue